module.exports = __webpack_public_path__ + "assets/2e580a1e17aa0b1319379cf046525001.mp4";